import clsx from 'clsx';
import type { FC } from 'react';
import type { CreateButtonProps } from '../../types';

const CreateButton: FC<CreateButtonProps> = ({
  onClick,
  isCreating,
  canCreate,
  disabledReason,
}) => {
  const isDisabled = !canCreate || isCreating;
  const title = !canCreate && disabledReason ? disabledReason : undefined;

  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx('personal-meetings-modal__add-button', {
        'personal-meetings-modal__add-button--disabled': isDisabled,
      })}
      disabled={isDisabled}
      title={title}
    >
      {isCreating ? 'CREATING…' : '+ ADD NEW MEETING ID'}
    </button>
  );
};

export default CreateButton;
